const scaleCartValidations = {
  _fetchCartItems: async function () {
    try {
      const response = await fetch(theme.routes.cart);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      return cartData.items || [];
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return [];
    }
  },

  _renderCart: function (cartDrawer, parsedState) {
    cartDrawer?.renderContents(parsedState);

    // get items still in cart to update cart bubble
    const cartItemCount = parsedState?.items?.length || 0;
    // update the top nav cart bubble if there are still items left in cart
    if (cartItemCount === 0) {
      const cartIconBubbleContainer = document.getElementById('cart-icon-bubble-container');
      if (cartIconBubbleContainer) {
        cartIconBubbleContainer.style.display = "none";
      }
      // else update cart bubble
    } else {
      const cartIconBubbleItemCount = document.getElementById('cart-icon-bubble-item-count');
      if (cartIconBubbleItemCount) {
        cartIconBubbleItemCount.innerHTML = cartItemCount;
      }
    }
  },

  validate: async function (
    items
  ) {
    const miniCart = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
    const cartDrawer = document.querySelector("cart-drawer");
    if (!miniCart || !cartDrawer) {
      console.error('Mini cart element not found');
      return;
    }
    const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    if (!items) {
      items = await this._fetchCartItems();
    }

    const previousLineItems = new Array();
    const updates = new Map();
    for (const line of items) {
      const isSub = !!line.selling_plan_allocation?.selling_plan?.id;

      const isDuplicate = previousLineItems.some(item => item.variantId === line.variant_id && item.isSub === isSub);
      if (!isDuplicate) {
        previousLineItems.push({
          variantId: line.variant_id,
          isSub,
        });
      }

      if (isDuplicate) {
        updates.set(line.key, 0);
      } else if (line.quantity > 1) {
        updates.set(line.key, 1);
      }
    }
    console.log('Cart validation updates:', updates);

    if (updates.size > 0) {
      const body = JSON.stringify({
        updates: Object.fromEntries(updates),
        sections,
      });
      try {
        miniCart.enableLoading(updates.entries().next().key);
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body,
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const state = await response.text();
        const parsedState = JSON.parse(state);

        this._renderCart(cartDrawer, parsedState);

        miniCart.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: state,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
        });
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
  }
};

if (!window.scaleCartValidations) {
  window.scaleCartValidations = scaleCartValidations;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    if (data.source === "cart-items") {
      scaleCartValidations.validate(data.cartData?.items);
    }
  });
}
